module.exports = __webpack_public_path__ + "assets/img/index-partner13.4e9a65dd.jpg";